if not App.angularApp?
    return

App.angularApp.directive 'mfAutoSelectOnlyOption', () ->
    return {
        restrict: 'A'
        require: 'uiSelect'
        link: (scope, element, attrs, uiSelect) =>
            if scope.$eval(attrs.mfAutoSelectOnlyOption) is false
                return

            scope.$watchCollection '$select.items', (items) ->
                # Make sure search is empty. Otherwise it would auto select while searching
                return if uiSelect.search isnt ''
                if items?.length is 1
                    # if the selected item is already the one, then return
                    selected = scope.$select.selected
                    return if selected is items[0] or (selected?.id? and items[0]?.id? and selected.id is items[0].id)
                    # doesn't work the first time without the $evalAsync. weird.
                    scope.$evalAsync () ->
                        scope.$select.select(items[0])
    }
